import React from 'react';
import { NavLink } from 'react-router-dom';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import ConnectionTool from '../../containers/ConnectionRoute';
import { useNavLinksQuery } from '../../services/api';
import CaretDown from '../icons/CaretDown';
import './Header.scss';
import NewsPaper from '../icons/NewsPaper';
import ChartLine from '../icons/ChartLine';
import Flask from '../icons/Flask';

const ListItem = React.forwardRef(
  ({ className, children, title, ...props }, forwardedRef) => (
    <li>
      <NavigationMenu.Link asChild>
        <NavLink
          className={`ListItemLink ${className ?? ''}`}
          {...props}
          ref={forwardedRef}
        >
          <div className="ListItemHeading">{title}</div>
          <p className="ListItemText">{children}</p>
        </NavLink>
      </NavigationMenu.Link>
    </li>
  ),
);

const Header = ({ display }) => {
  const { data = {}, isLoading } = useNavLinksQuery();

  if (!display || isLoading) {
    return null;
  }

  const { bulletinLinks, OMI, viewLinks, expertLinks } = data;

  return (
    <header role="banner" className="App-header shadow">
      <NavLink className="unstyledLink" to="/">
        <h2 className="App-title">
          <img
            className="logo"
            src="/favicon-70x70-1-white.png"
            alt="Mercator logo"
          />
          <span>oniqua</span>
        </h2>
      </NavLink>
      <NavigationMenu.Root role="navigation" className="NavigationMenuRoot">
        <NavigationMenu.List className="NavigationMenuList">
          <NavigationMenu.Item>
            <NavigationMenu.Trigger className="NavigationMenuTrigger">
              <NewsPaper size={18} aria-hidden />
              Access to bulletins
              <CaretDown className="CaretDown" aria-hidden />
            </NavigationMenu.Trigger>
            <NavigationMenu.Content className="NavigationMenuContent">
              <ul className="List">
                {[...bulletinLinks, OMI].map(({ name, to, description }) => (
                  <ListItem key={to} to={to} title={name}>
                    {description}
                  </ListItem>
                ))}
              </ul>
            </NavigationMenu.Content>
          </NavigationMenu.Item>

          <NavigationMenu.Item>
            <NavigationMenu.Trigger className="NavigationMenuTrigger">
              <ChartLine size={18} aria-hidden />
              Views
              <CaretDown className="CaretDown" aria-hidden />
            </NavigationMenu.Trigger>
            <NavigationMenu.Content className="NavigationMenuContent">
              <ul className="List">
                {viewLinks.map(({ name, to, description }) => (
                  <ListItem key={to} to={to} title={name}>
                    {description}
                  </ListItem>
                ))}
              </ul>
            </NavigationMenu.Content>
          </NavigationMenu.Item>

          <NavigationMenu.Item>
            <NavigationMenu.Trigger className="NavigationMenuTrigger">
              <Flask size={18} aria-hidden />
              Expert views
              <CaretDown className="CaretDown" aria-hidden />
            </NavigationMenu.Trigger>
            <NavigationMenu.Content className="NavigationMenuContent">
              <ul className="List">
                {expertLinks.map(({ name, to, description }) => (
                  <ListItem key={to} to={to} title={name}>
                    {description}
                  </ListItem>
                ))}
              </ul>
            </NavigationMenu.Content>
          </NavigationMenu.Item>

          <NavigationMenu.Item>
            <ConnectionTool />
          </NavigationMenu.Item>

          <NavigationMenu.Indicator className="NavigationMenuIndicator">
            <div className="Arrow" />
          </NavigationMenu.Indicator>
        </NavigationMenu.List>

        <div className="ViewportPosition">
          <NavigationMenu.Viewport className="NavigationMenuViewport" />
        </div>
      </NavigationMenu.Root>
    </header>
  );
};

export default Header;
